var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m12.78 2.59 2.532 5.111a.81.81 0 0 0 .652.478l5.589.828a.86.86 0 0 1 .477 1.48l-4.028 3.997a.84.84 0 0 0-.254.764l.97 5.62a.875.875 0 0 1-1.273.924l-5.031-2.66a.94.94 0 0 0-.828 0l-5.031 2.66a.876.876 0 0 1-1.274-.924l.971-5.684a.84.84 0 0 0-.254-.764l-4.076-3.932a.86.86 0 0 1 .525-1.481l5.589-.828a.81.81 0 0 0 .652-.478l2.532-5.11a.86.86 0 0 1 1.56 0"
})));
export default SvgStarFill;